/**
 * Derives the Firebase Functions base URL for the current environment.
 * Uses window.location.hostname so the iPad (on LAN) calls the dev machine
 * at its LAN IP instead of its own localhost.
 */
export function fnUrl(name) {
  if (import.meta.env.DEV) {
    const host = window.location.hostname;
    return `http://${host}:5001/byte-gaming/us-central1/${name}`;
  }
  return `https://us-central1-byte-gaming.cloudfunctions.net/${name}`;
}

/**
 * Rewrites Storage emulator URLs to use the current LAN hostname.
 * The Storage emulator issues download URLs with 127.0.0.1 which only works
 * on the dev machine itself — iPads and other LAN devices can't reach loopback.
 * In production the URLs are proper Firebase Storage CDN URLs; no rewrite needed.
 */
export function resolveUrl(url) {
  if (!url || !import.meta.env.DEV) return url;
  return url.replace(/http:\/\/(127\.0\.0\.1|localhost):/g, `http://${window.location.hostname}:`);
}
